import { TableOfContentsHeading } from '@models/tableOfContents';

type returnType = {
    nestedHeadingsH2H3: TableOfContentsHeading[];
    nestedHeadingsH3: TableOfContentsHeading[];
};

export function removeHTMLTagsFromText(text: string): string {
    const removeHeadersFromText = text.replace(/(?!<\/?a( |>))(<([^>]+)>)/gi, '');
    const removeHTMLSymbols = removeHeadersFromText.replace(/&nbsp;/gi, ' ');

    return removeHTMLSymbols.trim();
}

export function getIdFromHTMLTagText(text: string): string {
    const tagId = text.match('id="(.*)"');
    const id = tagId ? tagId[1] : '';

    return id;
}

export const getHeadingsFromContent = (content: string): returnType => {
    const headingsH2H3 = content.match(/<h([23]).*?>.*?<\/h\1>/g);
    const nestedHeadingsH2H3: TableOfContentsHeading[] = [];
    const nestedHeadingsH3: TableOfContentsHeading[] = [];

    if (headingsH2H3) {
        //if an article has h2 tags, create an array with a nested array
        if (headingsH2H3[0].includes('h2')) {
            headingsH2H3.map((header) => {
                if (header.includes('h2')) {
                    const textContent = removeHTMLTagsFromText(header);
                    const id = getIdFromHTMLTagText(header);
                    nestedHeadingsH2H3.push({ id: id, title: textContent, items: [] });
                } else if (header.includes('h3')) {
                    const textContent = removeHTMLTagsFromText(header);
                    const id = getIdFromHTMLTagText(header);
                    nestedHeadingsH2H3[nestedHeadingsH2H3.length - 1]?.items?.push({
                        id: id,
                        title: textContent,
                    });
                }
            });
        } else {
            // if no h2 tags, create an array only with h3
            headingsH2H3.map((header) => {
                const textContent = removeHTMLTagsFromText(header);
                const id = getIdFromHTMLTagText(header);
                nestedHeadingsH3.push({ id: id, title: textContent });
            });
        }
    }

    return { nestedHeadingsH2H3, nestedHeadingsH3 };
};
